<template>
  <div
    v-if="this.user.bruger_navn !== ''"
    id="bruger-info"
  >
    <h2>BRUGERINFO</h2>
    <div class="bruger-info-row">
      <span class="bruger-info-icon">
        <user-icon
          :iconColor="'rgba(210, 213, 228, 0.282)'"
          :width="16"
        />
      </span>
      <span
        v-if="editingUser === 'navn'"
        class="bruger-info-text"
      >
        <input
          @click.stop
          :value="this.user.bruger_navn"
          @keydown.enter="inputEnterKeyDown"
        /></span>
      <span
        v-else
        class="bruger-info-text"
      >{{this.user.bruger_navn}}</span>
      <button
        class="bruger-info-edit"
        @click.stop="setEditingUser('navn')"
      >
        <PenIcon
          :iconColor="'rgb(210, 213, 228)'"
          :width="16"
        />
      </button>
    </div>
    <div class="bruger-info-row">
      <span class="bruger-info-icon">
        <mail-icon
          :iconColor="'rgba(210, 213, 228, 0.282)'"
          :width="16"
        />
      </span>
      <span class="bruger-info-text">{{this.user.bruger_email}}</span>
    </div>
    <div class="bruger-info-row">
      <span class="bruger-info-icon">
        <graduation-icon
          :iconColor="'rgba(210, 213, 228, 0.282)'"
          :width="21"
        />
      </span>
      <span
        v-if="editingUser === 'institution'"
        class="bruger-info-text"
      >
        <select
          @click.stop
          @change="institutionSelectionChanged"
          :value="this.user.institution_id"
          v-if="institutioner.length"
        >
          <option
            v-for="i in institutioner"
            :key="i.id"
            :value="i.id"
          >{{i.navn}}</option>
        </select>
      </span>
      <span
        v-else
        class="bruger-info-text"
      >{{this.user.institution_navn}} <br /> {{this.user.institution_adresse}}</span>
      <button
        class="bruger-info-edit"
        @click.stop="editInstitution()"
      >
        <PenIcon
          :iconColor="'rgb(210, 213, 228)'"
          :width="16"
        />
      </button>
    </div>
    <div class="bruger-info-row">
      <button
        class="modal-default-button"
        @click="onLogout"
      >
        Log Ud
      </button>
    </div>
  </div>
  <div
    v-else-if="!loginProviderIsApi"
    id="bruger-info"
  >
    <div class="bruger-info-row">
      <button
        class="modal-default-button"
        @click="onLogin"
      >
        Log Ind
      </button>
    </div>
  </div>
</template>

<script>
import { config } from '@/config';
import UserIcon from '@/components/Icons/User';
import MailIcon from '@/components/Icons/Mail';
import PenIcon from '@/components/Icons/FilledCirclePen';
import GraduationIcon from '@/components/Icons/Graduation';
import store from '@/store';
import { signin, signout } from '@/auth';
import HmApi from '@/api/herningMobilitetApi';
export default {
  name: 'bruger-info',
  components: { UserIcon, MailIcon, GraduationIcon, PenIcon },
  props: {
    editingUser: String,
    setEditingUser: Function,
  },
  computed: {
    user() {
      if (this.$store.state.user !== null) {
        return this.$store.state.user;
      } else {
        return {
          bruger_navn: '',
          institution_navn: '',
          institution_adresse: '',
        };
      }
    },
  },
  data() {
    return {
      store: this.$store,
      loginProviderIsApi: config.auth.provider === 'api',
      loginProviderIsAuth0: config.auth.provider === 'auth0',
      loginProviderIsLocal: config.auth.provider === 'localStorage',
      updateUserName: HmApi.updateUserName,
      updateUserInstitution: HmApi.updateUserInstitution,
      getInstitutioner: HmApi.getInstitutioner,
      institutioner: [],
    };
  },

  methods: {
    onLogin() {
      if (this.loginProviderIsAuth0) {
        this.$auth.login();
      } else if (this.loginProviderIsLocal) {
        signin(this.email, this.pass).then(response => {
          if (response.token) {
            localStorage.setItem('token', response.token);
            this.$router.push({ name: 'home' });
          }
        });
      }
    },
    onLogout() {
      localStorage.removeItem('token');
      if (this.loginProviderIsAuth0) {
        this.$auth.logOut();
      } else {
        signout();
      }
      store.commit('updateUser', null);
      this.$router.push('/login');
    },
    institutionSelectionChanged(e) {
      const id = e.target.value;
      this.updateInstitution(id);
    },
    editInstitution() {
      this.setEditingUser('institution');
      if (!this.institutioner.length) {
        this.getInstitutioner('657').then(i => {
          this.institutioner = i;
        });
      }
    },
    updateInstitution(institutionId) {
      this.updateUserInstitution(this.user.bruger_id, institutionId).then(
        () => {
          const { user } = this.store.state;
          const institution = this.institutioner.find(i => {
            return i.id === institutionId;
          });
          const { adresse, aktiv, id, navn, placering } = institution;
          this.store.commit('updateUser', {
            ...user,
            institution_adresse: adresse,
            institution_aktiv: aktiv,
            institution_id: id,
            institution_navn: navn,
            institution_placering: placering,
          });
          this.setEditingUser(undefined);
        }
      );
    },
    inputEnterKeyDown(e) {
      const name = e.target.value;
      this.updateName(name);
    },
    updateName(name) {
      console.log(name);
      this.updateUserName(this.user.bruger_id, name).then(() => {
        this.setEditingUser(undefined);
        const { user } = this.store.state;
        this.store.commit('updateUser', { ...user, bruger_navn: name });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#bruger-info {
  padding: 10px 90px;
  .bruger-info-icon {
    width: 25px;
  }
  .bruger-info-text {
    margin-left: 22px;
    flex: 1;
    input,
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      width: 100%;
      height: 30px;
      padding: 4px;
      font-size: 16px;
      border-radius: 3px;
      background: #f7f7fa;
      border: 1px solid #f7f7fa;
      color: $primary-700;
      &:focus {
        border: 1px solid #6a72a6;
        outline: none;
      }
      &:hover {
        border: 1px solid #6a72a6;
      }
    }
    select {
      -moz-appearance: none;
      -webkit-appearance: none;
      padding-right: 25px;
      appearance: none;
      background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%230f1c70%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
      background-repeat: no-repeat;
      background-position: right 0.7em top 50%, 0 0;
      background-size: 0.65em auto, 100%;
      &:hover {
        border: 1px solid #6a72a6;
      }
    }
  }
  .bruger-info-row {
    display: flex;
    align-items: center;
    margin-top: 24px;
  }
  h2 {
    color: rgba(255, 255, 255, 0.392);
    padding-left: 46px;
  }
  button {
    background-color: rgba(255, 255, 255, 0.4);
    border: none;
    color: #ffffff;
    border-radius: 3px;
    padding: 0;
    font: inherit;
    cursor: pointer;
    width: 130px;
    margin: 16px auto;
    height: 42px;
    font-weight: 600;
  }
  .bruger-info-edit {
    margin: unset;
    margin-left: auto;
    width: 42px;
    background: none;
    svg {
      opacity: 0.282;
    }
    &:hover svg {
      opacity: 1;
    }
  }
}
@media only screen and (max-width: $tablet-landscape-max-width),
  screen and (max-height: 800px) {
  #bruger-info {
    padding: 20px 30px;
    font-size: 15px;
    .bruger-info-text {
      margin-left: 12px;
    }
    h2 {
      padding-left: 36px;
    }
  }
}

@media only screen and (max-width: $tablet-max-width) {
  #bruger-info {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 25px 0;
    background-color: $primary-700;
    > * {
      width: 85%;
      margin-left: auto;
      margin-right: auto;
    }
    .bruger-info-row {
      margin-top: 16px;
    }
  }
}
</style>
